export default (props, vars) => !props?.['applicationOffer']?.['is_neutral'];
